export default {
  curatorMetadata: {
    userHeaders: {
      name: 'ФИО сотрудника',
      employeeAvg: 'Ср. оценка сотрудника',
      curatorAvg: 'Ср. оценка </br> руководителя/куратора',
      curatorAvgMobile: 'Ср. оценка руководителя/куратора',
      efficiency: 'Эффективность',
    },
    adaptationHeaders: {
      planName: 'План',
      teamName: 'Команда',
      dateStart: 'Дата старта',
      progress: 'Прогресс',
      statistics: 'Статистика',
    },
    noPlans: 'У вас ещё нет ни одной курируемой адаптации.',
    exportFileName: 'Результаты_по_целям_курируемых_сотрудников',
    targetHeaders: {
      name: 'Наименование цели',
      importance: 'Важность',
      status: 'Статус',
      employeeScore: 'Оценка сотрудника',
      curatorScore: 'Оценка </br> руководителя/куратора',
      curatorScoreMobile: 'Оценка руководителя/куратора',
      type: 'Тип',
      progress: 'Прогресс',
      deadline: 'Дедлайн',
    },
    confirmArchiveTargets: {
      title: 'Перемещение целей в архив',
      button: 'Да, перенести',
      text: 'Вы действительно хотите перенести цели в архив? Архивные цели не будут участвовать в расчёте эффективности и средних оценок.',
    },
    confirmUnarchiveTargets: {
      title: 'Перемещение целей из архива в текущие',
      button: 'Да, перенести',
      text: 'Вы действительно хотите перенести цели в список текущих?',
    },
    confirmMoveTargets: {
      title: 'Изменить статус целей?',
      button: 'Да, изменить',
      text: 'Статус выбранных целей будет изменён на: «{status}»',
    },
    exportTargets: 'Выгрузить в excel все результаты по всем курируемым сотрудникам',
    efficiency: 'Процент завершенных целей от согласованных',
    scoreAvg:
      'Средняя рассчитана как среднее арифметическое взвешенное всех оценок по цели: сумма целей, умноженных на свои веса, делённая на сумму всех весов. Вес цели определяется автоматически в зависимости от установленной важности.',
    successMessages: {
      archiveTargets: 'Цели успешно перемещены в архив',
      unarchiveTargets: 'Цели успешно перемещены в текущие',
      moveTarget: 'Статус цели «{targetName}» успешно изменён',
    },
    errorMessages: {
      archiveTargets: 'Не удалось переместить цели в архив',
      unarchiveTargets: 'Не удалось переместить цели в текущие',
      moveTarget: 'Не удалось изменить статус цели «{targetName}»',
      exportTargets: 'Не удалось выгрузить результаты',
    },
    noTargets: 'У вас ещё нет ни одной курируемой цели.',
    noArchivalTargets: 'У вас ещё нет ни одной архивной цели.',
  },
};
